import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const mapProducts = async ({ marketplaceId, body }) => {
  const path = `/marketplaces/${marketplaceId}/map_products/`;
  try {
    const response = await axiosInstance.post(path, { ...body, async: true });
    return response.data;
  } catch (error) {
    console.error('Map Products API error:', error);
    throw error;
  }
};

export const useMapProducts = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: mapProducts,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['marketplaces'] });
      queryClient.invalidateQueries({ queryKey: ['products'] });

      // Appelle le callback onSuccess personnalisé s'il existe
      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    mapProducts: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
